import { Box, VStack, Icon } from '@chakra-ui/react';

import Content from '~/containers/Content';
import PageContainer from '~/containers/PageContainer';
import SectionContainer from '~/containers/SectionContainer';

import { MealBoxNotice, SearchLocation } from './components';

import useContainerCount from './hooks/useContainerCount';

import { MealBox } from '~/icons';

export default function MealBoxRecycling() {
  const { containerCount } = useContainerCount();
  return (
    <PageContainer>
      <Box bg="white" minH="70vh">
        <Content>
          <VStack p={4} align="stretch">
            <SectionContainer
              title="餐盒回收"
              icon={<Icon as={MealBox} color="secondary" boxSize="1.25rem" />}
            >
              <MealBoxNotice num={containerCount} />
              <SearchLocation />
            </SectionContainer>
          </VStack>
        </Content>
      </Box>
    </PageContainer>
  );
}
